import { Skeleton } from "@/components/ui/skeleton"

export default function CategoryProductsLoading() {
  return (
    <div className="content-container mt-8">
      <div className="mb-8 flex items-center justify-between bg-bg-component p-4 rounded-lg">
        <div className="flex items-center">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="mx-8 h-px flex-1" />
        </div>
        <Skeleton className="h-10 w-32" />
      </div>
      
      {/* Product rail skeleton */}
      <div className="flex gap-4 overflow-x-auto pb-4 no-scrollbar">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex-shrink-0 w-64">
            <div className="bg-bg-component rounded-lg overflow-hidden">
              <Skeleton className="w-full h-48" />
              <div className="p-4 space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-6 w-24" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

